import script from "./Illustration-item.vue?vue&type=script&setup=true&name=src%2Fcomponents%2FillustrationList.vue&lang=js"
export * from "./Illustration-item.vue?vue&type=script&setup=true&name=src%2Fcomponents%2FillustrationList.vue&lang=js"

import "./Illustration-item.vue?vue&type=style&index=0&id=2599cc18&lang=css"

const __exports__ = script;

export default __exports__